<template>
  <input type="tel" :value="modelValue" ref="phoneInput" class="form-control" :class="{'form-control-sm': size == 'sm'}">
</template>

<script>
import Cleave from 'cleave.js'

export default {
  props: {
    modelValue: { require: true },
    size: { default: null },
  },
  mounted() {
    setTimeout(() => {
      const phoneInput = new Cleave(this.$refs.phoneInput, {
        numericOnly: true,
        blocks: [0, 3, 0, 3, 4],
        delimiters: ["(", ")", " ", "-"],
      })
    }, 750)

    this.$refs.phoneInput.oninput = (e) => {
      this.$emit('update:modelValue', e.target.value)
    }
  }
}
</script>
